import Checkbox from '../checkbox';
import Radio from '../radio';
import Intact from 'intact';
import {noop, isStringOrNumber, getTextByChildren, getRestProps, mapChildren} from '../utils';
import {isInvisible} from './utils';
import Button from '../button';
import Icon from '../icon';

export default function(obj, _Vdt, blocks, $callee) {
    _Vdt || (_Vdt = Vdt);
    obj || (obj = {});
    blocks || (blocks = {});
    var h = _Vdt.miss.h, hc = _Vdt.miss.hc, hu = _Vdt.miss.hu, widgets = this && this.widgets || {}, _blocks = {}, __blocks = {},
        __u = _Vdt.utils, extend = __u.extend, _e = __u.error, _className = __u.className, __slice = __u.slice, __noop = __u.noop,
        __m = __u.map, __o = __u.Options, _getModel = __o.getModel, _setModel = __o.setModel,
        _setCheckboxModel = __u.setCheckboxModel, _detectCheckboxChecked = __u.detectCheckboxChecked,
        _setSelectModel = __u.setSelectModel,
        self = this.data, $this = this, scope = obj, Animate = self && self.Animate, parent = ($callee || {})._super;

    const {
    className, checkType, rowKey,
    disabled, onlyRight, scheme,
    value, onlyLeft, index, merge,
    level, indent, children, grid,
    checked, draggable, dragKey, 
    rowKeys, firstCloumnRowSpans
} = self.get();
const normalize = Intact.normalize;

const rowInGrid = self.rowInGrid = [];
const spanColumnsInfo = self.spanColumnsInfo = {};

if (merge) {
    grid.push(rowInGrid);
    firstCloumnRowSpans.push(spanColumnsInfo)
}

let columnIndex = -1;

const combinedScheme = checkType !== 'none' ? Object.assign({ checkType: {key: '$check'} }, scheme) : scheme;

    return h('tr', {
        'draggable': function() {try {return (draggable ? true : undefined )} catch(e) {_e(e)}}.call($this),
        'ev-click': function() {try {return (self._onClick )} catch(e) {_e(e)}}.call($this),
        'ev-mouseenter': function() {try {return (self._onMouseEnter )} catch(e) {_e(e)}}.call($this),
        'ev-mouseleave': function() {try {return (self._onMouseLeave )} catch(e) {_e(e)}}.call($this),
        'ev-dragstart': function() {try {return (draggable ? self._onDragStart : undefined )} catch(e) {_e(e)}}.call($this),
        'ev-dragend': function() {try {return (draggable ? self._onDragEnd : undefined )} catch(e) {_e(e)}}.call($this),
        'ev-dragover': function() {try {return (draggable ? self._onDragOver : undefined )} catch(e) {_e(e)}}.call($this)
    }, function() {try {return (__u.map(combinedScheme, (item, schemeKey) => {
        columnIndex++;
        let spans;
        if (merge) {
            if (columnIndex > 0) {
                const prevCell = rowInGrid[columnIndex - 1];
                if (prevCell && prevCell.colspan > 1) {
                    const current = {
                        rowspan: prevCell.rowspan,
                        colspan: prevCell.colspan - 1,
                    };
                    rowInGrid.push(current);
                    return;
                }
            }
            if (index > 0) {
                const prevRow = grid[index - 1];
                const aboveCell = prevRow[columnIndex];
                if (aboveCell && aboveCell.rowspan > 1) {
                    const current = { 
                        rowspan: aboveCell.rowspan - 1,
                        colspan: aboveCell.colspan,
                    }
                    rowInGrid.push(current);

                    if(columnIndex === 0 && checkType !== 'none'){
                        const spanColumns = firstCloumnRowSpans[index - 1];
                        spanColumnsInfo.spanRowKeys = spanColumns.spanRowKeys;
                        spanColumnsInfo.spanIndexs = spanColumns.spanIndexs;
                    }
                    return;
                }
            }

            spans = merge.call(self, value, item, index, columnIndex);
            rowInGrid.push(spans);
            
            if(columnIndex === 0 && checkType !== 'none'){
                const firstColumnRowspan = spans.rowspan || 1;
                const endRowIndex = index + firstColumnRowspan; 
                const spanColumns = firstColumnRowspan > 1 ? {
                        spanRowKeys: rowKeys.slice(index, endRowIndex), 
                        spanIndexs:  Array.from(new Array(endRowIndex).keys()).slice(index)
                    } : {
                        spanRowKeys: rowKey, spanIndexs: index
                    };
                spanColumnsInfo.spanRowKeys = spanColumns.spanRowKeys;
                spanColumnsInfo.spanIndexs = spanColumns.spanIndexs;
            }
        }
        let td;
        if (item.template) {
            if (typeof item.template === 'function') {
                td = item.template.call(self, value, index);
                // for Intact-Vue
                if (normalize) {
                    td = normalize(td);
                }
            } else {
                td = item.template;
            }
        } else if (item.blockFn) {
            td = item.blockFn.call(self, noop, value, index);
        } else if (value[schemeKey] !== undefined) {
            td = value[schemeKey];
        } else {
            let obj = value,
                keys = schemeKey.split('.'),
                i = 0;
            while (obj != null && i < keys.length) {
                obj = obj[keys[i++]];
            }
            td = (i && i === keys.length) ? obj : null;
        }
     
        if(columnIndex===0 && checkType !== 'none' ){
            return  checkType === 'checkbox' ? h('td', {
        ...function() {try {return (spans )} catch(e) {_e(e)}}.call($this),
        'data-column': function() {try {return (spans && spans.rowspan > 1 ? "k-first-column" : undefined  )} catch(e) {_e(e)}}.call($this)
    }, h(Checkbox, {
        'name': 'k-table-checkbox',
        'indeterminate': function() {try {return (self._isHalfChecked() )} catch(e) {_e(e)}}.call($this),
        'value': function() {try {return (self._isAllChecked() )} catch(e) {_e(e)}}.call($this),
        'disabled': function() {try {return (self._isDisabled() )} catch(e) {_e(e)}}.call($this),
        '_context': $this,
        'ev-$change:value': function() {try {return (self._onChangeChecked )} catch(e) {_e(e)}}.call($this)
    }), _className(function() {try {return ({"k-th-check": true, 'k-invisible': onlyRight} )} catch(e) {_e(e)}}.call($this))) : h('td', {
        ...function() {try {return (spans )} catch(e) {_e(e)}}.call($this)
    }, h(Radio, {
        'name': 'k-table-radio',
        'value': function() {try {return (self._isAllChecked() )} catch(e) {_e(e)}}.call($this),
        'disabled': function() {try {return (self._isDisabled() )} catch(e) {_e(e)}}.call($this),
        '_context': $this,
        'ev-$change:value': function() {try {return (self._onChangeChecked )} catch(e) {_e(e)}}.call($this)
    }), _className(function() {try {return ({"k-th-check": true, 'k-invisible': onlyRight} )} catch(e) {_e(e)}}.call($this)))
        }else{
            const isFirstEleColumn = checkType === 'none' ? columnIndex === 0 : columnIndex === 1;

            return h('td', {
        'title': function() {try {return (getTextByChildren(td) || undefined )} catch(e) {_e(e)}}.call($this),
        'data-ignore': function() {try {return (item.ignore ? '' : undefined )} catch(e) {_e(e)}}.call($this),
        ...function() {try {return (spans )} catch(e) {_e(e)}}.call($this),
        'style': function() {try {return ({paddingLeft: isFirstEleColumn && level ? level * indent + 'px' : undefined } )} catch(e) {_e(e)}}.call($this)
    }, [
        function() {try {return (isFirstEleColumn && children )} catch(e) {_e(e)}}.call($this) ?
            h(Button, {
                'type': 'none',
                'icon': function() {try {return (true)} catch(e) {_e(e)}}.call($this),
                'circle': function() {try {return (true)} catch(e) {_e(e)}}.call($this),
                'size': 'mini',
                'className': 'k-table-arrow',
                'children': h(Icon, {
                    'className': 'ion-ios-arrow-right',
                    'size': 'small',
                    '_context': $this
                }),
                '_context': $this,
                'ev-click': function() {try {return (self._onToggleSpreadRow )} catch(e) {_e(e)}}.call($this)
            }) :
            undefined,
        function() {try {return (typeof td === 'boolean' ? String(td) : td )} catch(e) {_e(e)}}.call($this)
    ], _className(function() {try {return ({
                        'k-invisible': isInvisible(onlyLeft, onlyRight, item),
                        [`k-${item.align}`]: item.align,
                        [item.className]: item.className,
                    } )} catch(e) {_e(e)}}.call($this)), function() {try {return (schemeKey )} catch(e) {_e(e)}}.call($this))
        }
       
    }) )} catch(e) {_e(e)}}.call($this), _className(function() {try {return ({[className]: className, 'k-dragging': dragKey === rowKey} )} catch(e) {_e(e)}}.call($this)))
}